module.exports = __webpack_public_path__ + "img/upload-icon.1018b88e.svg";